import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19cb3723"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RPKListItem" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "RPKListItem__content" }
const _hoisted_5 = { class: "flex w-full justify-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, " ID: " + _toDisplayString(_ctx.item.id), 1),
      (_ctx.item.status)
        ? (_openBlock(), _createBlock(_component_cheap, {
            key: 0,
            class: _normalizeClass(["small", _ctx.getStatusColor(_ctx.item.status_type)])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.status), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, "Дата акта: " + _toDisplayString(_ctx.formatDate(_ctx.item.act_date)), 1),
      _createElementVNode("span", null, "Номер акта: " + _toDisplayString(_ctx.item.act_number || 'Нет данных'), 1),
      _createElementVNode("span", null, "Дата создания: " + _toDisplayString(_ctx.formatDate(_ctx.item.created_at)), 1),
      _createElementVNode("span", null, "Стоимость: " + _toDisplayString(_ctx.item.total_price ? _ctx.item.total_price + ' ₸' : 'Нет данных'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.exportExcel,
        loading: _ctx.state.is_loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Скачать в Excel ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_router_link, {
        to: `/rpk/raketa/${_ctx.item.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "text small primary" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode("Подробнее ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}